import React, { useState } from "react";
import { projectsData } from "../data";
import { projectsNav } from "../data";
import Project from "./Project";

const Projects = () => {
  const [category, setCategory] = useState("web development");

  const handleClick = (name) => {
    setCategory(name.toLowerCase());
  };

  return (
    <div>
      {/* projects nav */}
      <nav className="mb-12 max-w-xl mx-auto">
        <ul className="flex flex-col md:flex-row justify-evenly items-center text-white">
          {projectsNav.map((item) => {
            return (
              <li
                onClick={(e) => {
                  handleClick(item.name);
                }}
                className={`cursor-pointer capitalize m-4 ${
                  item.name === category && "active"
                } `}
                key={item.name}
              >
                {item.name}
              </li>
            );
          })}
        </ul>
      </nav>
      {/* projects */}
      <section className="grid gap-y-12 lg:grid-cols-3 lg:gap-x-8 lg:gap-y-8">
        {[...projectsData].reverse()
          .filter((project) =>
            category === "all" ? true : project.category === category
          )
          .map((item) => {
            return <Project item={item} key={item.id} />;
          })}
      </section>
    </div>
  );
};

export default Projects;
